export default function BreadFallback() {
  return (
    <div className="flex flex-wrap gap-3 gap-y-2 lg:px-0 lg:justify-center m-auto z-[9] static top-auto left-auto animate-pulse my-8 xl:mb-16 max-w-[740px] mx-auto">
      <div className="flex gap-3 justify-center min-w-[70px] py-3 px-3 rounded-md bg-grey100 h-2"></div>
      <div className="flex gap-3 justify-center min-w-[70px] py-3 px-3 rounded-md bg-grey100 h-2"></div>
      <div className="flex gap-3 justify-center min-w-[70px] py-3 px-3 rounded-md bg-grey100 h-2"></div>
      <div className="flex gap-3 justify-center min-w-[70px] py-3 px-3 rounded-md bg-grey100 h-2"></div>
      <div className="flex gap-3 justify-center min-w-[70px] py-3 px-3 rounded-md bg-grey100 h-2"></div>
    </div>
  );
}
